import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/kyc")({
  component: lazyRouteComponent(() => import("@/pages/admin/Kyc")),
});
